import React from "react";
import "./DefaultScreen.css";
import WelcomeNameContainer from "./WelcomeNameContainer";

const DefaultScreen = () => {
 return (
  <>
   <div className="landing-page-container">
    <WelcomeNameContainer />
    <div className="landing-page-wrap">
     <img
      src={process.env.PUBLIC_URL + "/Images/comms_icon.png"}
      className="comms_icon"
     />
     <p className="landing-page-wrap-content">Create Faster, Communicate Better</p>
      <p style={{ fontSize: "12px", marginTop: "7px" }}>
           Click <a href="https://wd103.myworkday.com/accenture/learning/course/02a7a7afc42510010d0615a841130001" target="_blank">here</a> to Learn more about CommsBuilder Tool.
          </p> 
    </div>
   </div>
  </>
 );
};

export default DefaultScreen;
